<template>
    <q-dialog
        :model-value="store.open"
        @update:model-value="store.close()"
        backdrop-filter="blur(4px) grayscale(50%)">
        <q-card style="min-width: 420px; max-width: 520px;">
            <q-card-section class="row items-center q-pb-none">
                <q-icon name="lock_open" color="primary" size="sm" class="q-mr-sm" />
                <div class="text-h6">Upgrade Required</div>
                <q-space />
                <q-btn icon="close" flat round dense @click="store.close()" />
            </q-card-section>

            <q-card-section>
                <div class="text-body1 q-mb-sm">
                    <strong>{{ store.featureLabel }}</strong> is not included in your current plan.
                </div>
                <div v-if="store.actionContext" class="text-body2 text-grey-7 q-mb-md">
                    {{ store.actionContext }} requires an upgraded plan.
                </div>
                <div class="text-body2 text-grey-7">
                    Compare plans and upgrade to unlock this feature.
                </div>
            </q-card-section>

            <q-card-actions align="right" class="q-pa-md">
                <q-btn flat label="Not Now" @click="store.close()" />
                <q-btn
                    color="primary"
                    unelevated
                    icon-right="arrow_forward"
                    label="View Plans & Upgrade"
                    href="/Settings/Subscription" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
/**
 * UpgradePromptDialog - global dialog that surfaces when a user attempts an
 * action gated by their subscription plan. Mounted once in AppLayout.vue.
 *
 * Opened via the upgradePrompt Pinia store's `guard()` or `openDialog()` action.
 * The dialog is purely informational + CTA; it does NOT perform the gated
 * action even if the user clicks the CTA (the CTA navigates to the plan
 * comparison page).
 */
import { useUpgradePromptStore } from '@stores/upgradePrompt.js';

export default {
    name: 'UpgradePromptDialog',
    setup() {
        return { store: useUpgradePromptStore() };
    }
};
</script>
